import { Component } from "react";
import Utilities from "../global/Utilities"
import { API_CONSTANTS, ENVIRONMENT } from "../global/Constants"

export default class ApiServices extends Component {
    static myInstance = null;

    static getInstance() {
        if (ApiServices.myInstance == null) {
            ApiServices.myInstance = new ApiServices();
        }
        return this.myInstance;
    }

    static jwtToken = "";

    static getToken() {
        return ApiServices.jwtToken;
    }

    static setToken(newToken) {
        ApiServices.jwtToken = newToken;
    }

    static getTimeStamp = () => {
        return new Date().getTime()
    }

    // Get Api
    static _getData(URL) {
        let token = localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN);
        return fetch(ENVIRONMENT.BASE_URL + URL, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": token,
            },
        })
            .then(response => response.json())
            .then((responseJson) => {
                let response = null;
                try {
                    response = JSON.parse(responseJson);
                } catch (e) {
                    response = responseJson;
                }
                return response;
            })
            .catch(err => {
                Utilities.LogPrint("GET ERROR : " + URL, err.message);
                return false;
                // return Promise.reject(err);
            })
    }

    //Post api
    static _postData(URL, params) {
        let refreshToken = localStorage.getItem('refreshToken');
        let token = localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN);
        //Utilities.LogPrint("_postData", { Api: URL, data: params });
        let headerData = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": token,
            "X-Refresh-Token": refreshToken,
        }
        //Utilities.LogPrint("headerData", headerData);
        const requestURL = ENVIRONMENT.BASE_URL + URL;
        return fetch(requestURL, {
            method: 'POST',
            headers: headerData,
            body: params
        })
            .then(response => response.json())
            .then((responseJson) => {
                //console.log("responseJson", responseJson)
                // if (responseJson?.statusCode === 401) {
                //     this.tokenExpired()
                // }

                let response = null;
                try {
                    response = JSON.parse(responseJson);
                } catch (e) {
                    response = responseJson;
                }
                return response;
            })
            .catch(err => {
                Utilities.LogPrint("POST ERROR : " + URL, err.message);
                return false;
            })
    }

    //Post XML api
    static _postXMLData(URL, params) {
        let refreshToken = localStorage.getItem('refreshToken');
        let token = localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN);
        //Utilities.LogPrint("_postData", { Api: URL, data: params });
        let headerData = {
            Accept: "application/xml",
            "Content-Type": "application/json",
            "Authorization": token,
            "X-Refresh-Token": refreshToken,
        }
        //Utilities.LogPrint("headerData", headerData);
        const requestURL = ENVIRONMENT.BASE_URL + URL;
        return fetch(requestURL, {
            method: 'POST',
            headers: headerData,
            body: params
        })
            .then(response => response.blob())
            .catch(err => {
                Utilities.LogPrint("POST ERROR : " + URL, err.message);
                return false;
            })
    }

    //Post verifyOTP api
    static _postVerifyOTPData(URL, params, token) {
        Utilities.LogPrint("_postData", { Api: URL, data: params, });
        let headerData = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token
        }
        //Utilities.LogPrint("headerData", headerData);
        const requestURL = ENVIRONMENT.BASE_URL + URL;
        return fetch(requestURL, {
            method: 'POST',
            headers: headerData,
            body: params
        })
            .then(response => response.json())
            .then((responseJson) => {

                let response = null;
                try {
                    response = JSON.parse(responseJson);
                } catch (e) {
                    response = responseJson;
                }
                return response;
            })
            .catch(err => {
                Utilities.LogPrint("POST ERROR : " + URL, err.message);
                return false;
            })
    }

    //Post List API
    static _postDataList(URL, params) {
        //Utilities.LogPrint("_postData", { Api: URL, data: params });
        const requestURL = ENVIRONMENT.BASE_URL + URL;
        return fetch(requestURL, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": ENVIRONMENT.BEARER_TOKEN
            },
            body: params
        })
            .then(response => response.json())
            .then((responseJson) => {

                let response = null;
                try {
                    response = JSON.parse(responseJson);
                } catch (e) {
                    response = responseJson;
                }
                return response;
            })
            .catch(err => {
                Utilities.LogPrint("POST ERROR : " + URL, err.message);
                return false;
            })
    }


    //Form Data Post API
    static _postFormData(URL, params) {
        let token = localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN);
        //Utilities.LogPrint("_postData", { Api: URL, data: params });
        let headerData = {
            "Authorization": token,
        }
        //Utilities.LogPrint("headerData", headerData);
        const requestURL = ENVIRONMENT.BASE_URL + URL;
        return fetch(requestURL, {
            method: 'POST',
            headers: headerData,
            body: params
        })
            .then(response => response.json())
            .then((responseJson) => {

                let response = null;
                try {
                    response = JSON.parse(responseJson);
                } catch (e) {
                    response = responseJson;
                }
                return response;
            })
            .catch(err => {
                Utilities.LogPrint("POST ERROR : " + URL, err.message);
                return false;
            })
    }


    static _postDataRefresh(URL, params) {
        let token = localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN);
        let refreshToken = localStorage.getItem('refreshToken');
        Utilities.LogPrint("_postData", { Api: URL, data: params });
        const requestURL = ENVIRONMENT.BASE_URL + URL;
        return fetch(requestURL, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": token,
                "X-Refresh-Token": refreshToken
            },
            body: params
        })
            .then(response => response.json())
            .then((responseJson) => {

                let response = null;
                try {
                    response = JSON.parse(responseJson);
                } catch (e) {
                    response = responseJson;
                }
                return response;
            })
            .catch(err => {
                Utilities.LogPrint("POST ERROR : " + URL, err.message);
                return false;
            })
    }

    // --- End --- //

    //***** Sync Service *****//
    static syncData(params) {
        var response = this._postFormData(API_CONSTANTS.SYNC_DATA, params)
        return response;
    }
    static syncKrishakData(params) {
        var response = this._postFormData(API_CONSTANTS.SYNC_KRISHAK_DATA, params)
        return response;
    }
    static syncActivityData(params) {
        var response = this._postFormData(API_CONSTANTS.SYNC_ACTIVITY_DATA, params)
        return response;
    }

    //***** Login Module *****//
    static logIn(params) {
        var response = this._postDataList(API_CONSTANTS.LOGIN_URL, params)
        return response;
    }

    static register(params) {
        var response = this._postDataList(API_CONSTANTS.REGISTER_URL, params)
        return response;
    }

    static forgetEmployeeId(params) {
        var response = this._postDataList(API_CONSTANTS.REGISTER_RECOVER, params)
        return response;
    }

    // Send OTP to user Mobile number or Email 
    static sendOtp(params) {
        var response = this._postData(API_CONSTANTS.SEND_OTP_URL, params)
        return response;
    }

    static verifyUserOtp(params, token) {
        var response = this._postVerifyOTPData(API_CONSTANTS.VERIFY_OTP_URL, params, token)
        return response;
    }

    static setUserPassword(params) {
        var response = this._postData(API_CONSTANTS.CREATE_PASSWORD_URL, params)
        return response;
    }

    static forgotPassword(params) {
        var response = this._postDataList(API_CONSTANTS.FORGOT_PASSWORD, params)
        return response;
    }

    //Login & Change password ===> Update Password
    static updatePassword(params) {
        var response = this._postData(API_CONSTANTS.UPDATE_PASSWORD, params)
        return response;
    }

    //Profile Management ===> Change Password
    static changePassword(params) {
        var response = this._postDataRefresh(API_CONSTANTS.CHANGE_PASSWORD, params)
        return response;
    }

    static logout() {
        var response = this._postData(API_CONSTANTS.LOGOUT)
        return response;
    }


    // New Requirement API For Adding Retailer Registration 
    static sentRetailerOtp(params) {
        var response = this._postData(API_CONSTANTS.SENT_RETAILER_OTP, params);
        return response;
    }

    static verifyRetailerOtp(params) {
        var response = this._postData(API_CONSTANTS.VERIFY_RETAILER_OTP, params);
        return response;
    }

    static addRetailer(params) {
        var response = this._postData(API_CONSTANTS.ADD_RETAILER, params);
        return response;
    }


    //***** Home Page Module *****//
    static getTodayActivity(params) {
        var response = this._postData(API_CONSTANTS.GET_TODAY_ACTIVITY, params)
        return response;
    }

    static getFdoActivityByDate(params) {
        var response = this._postData(API_CONSTANTS.GET_FDO_ACTIVITY_BYDATE, params)
        return response;
    }

    static addUserStartEndDay(params) {
        var response = this._postData(API_CONSTANTS.START_END_DAY, params)
        return response;
    }

    static editActivity(params) {
        var response = this._postFormData(API_CONSTANTS.EDIT_ACTIVITY, params)
        return response;
    }

    static getActivityById(params) {
        var response = this._postData(API_CONSTANTS.GET_ACTIVITY_BY_ID, params);
        return response;
    }

    static getRetailerByActivityId(params) {
        var response = this._postData(API_CONSTANTS.GET_RETAILER_BY_ACTIVITY_ID, params);
        return response;
    }

    static getCheckVariety(params) {
        var response = this._postData(API_CONSTANTS.GET_CHECK_VARIETY_BY_REFERENCE_ID, params);
        return response;
    }

    static deleteActivity(params) {
        var response = this._postData(API_CONSTANTS.EDIT_ACTIVITY_BY_ID, params)
        return response;
    }

    static deleteActivityImage(params) {
        var response = this._postData(API_CONSTANTS.DELETE_ACTIVITY_IMAGE, params)
        return response;
    }

    static deleteKrishakImage(params) {
        var response = this._postData(API_CONSTANTS.DELETE_KRISHAK_IMAGE, params)
        return response;
    }

    static deleteKrishakFellowFarmerImage(params) {
        var response = this._postData(API_CONSTANTS.DELETE_KRISHAK_FELLOW_FARMER_IMAGE, params)
        return response;
    }

    static getKrishakByReferenceId(params) {
        var response = this._postData(API_CONSTANTS.GET_KRISHAK_BY_REFERENCE_ID, params)
        return response;
    }

    static deleteGroupMeetingImage(params) {
        var response = this._postData(API_CONSTANTS.DELETE_GROUP_MEETING_IMAGE, params)
        return response;
    }

    static deleteGroupMeetingFarmerImage(params) {
        var response = this._postData(API_CONSTANTS.DELETE_GM_FARMER_IMAGE, params)
        return response;
    }

    static getGroverByUserId(params) {
        var response = this._postData(API_CONSTANTS.GET_GROVER_BY_USER_ID, params);
        return response;
    }


    //***** Home Page -> Add Activity Module *****//
    static getFDO() {
        var response = this._postData(API_CONSTANTS.GET_FDO)
        return response;
    }

    static getActivityFDO() {
        var response = this._postData(API_CONSTANTS.GET_ACTIVITY_FDO)
        return response;
    }

    static getAllActivityType() {
        var response = this._getData(API_CONSTANTS.GET_ALL_ACTIVITY_TYPE)
        return response;
    }

    static getSubActivityById(params) {
        var response = this._postData(API_CONSTANTS.GET_SUBACTIVITY_BYID, params)
        return response;
    }

    static getSubActivityByReferenceId(params) {
        var response = this._postData(API_CONSTANTS.GET_SUBACTIVITY_BY_ID, params)
        return response;
    }

    static getTypeOfSample(params) {
        var response = this._postData(API_CONSTANTS.GET_TYPE_OF_SAMPLE, params)
        return response;
    }

    static getAllVillage() {
        var response = this._getData(API_CONSTANTS.GET_ALL_VILLAGE)
        return response;
    }

    static addActivity(params) {
        var response = this._postData(API_CONSTANTS.ADD_ACTIVITY, params)
        return response;
    }

    static activityBulkUpload(params) {
        var response = this._postData(API_CONSTANTS.ACTIVITY_BULK_UPLOAD, params)
        return response;
    }


    //***** Krishak Module *****//
    static getAllStates(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_STATES, params)
        return response;
    }

    static getAllPrerak(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_PRERAK, params)
        return response;
    }

    static krishakReport(params) {
        var response = this._postData(API_CONSTANTS.KRISHAK_REPORT, params)
        return response;
    }

    static getUserLocationReport(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_LOCATION_REPORT, params)
        return response;
    }

    static getUserFeedbackByUserId(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_FEEDBACK_BY_USER_ID, params)
        return response;
    }

    static exportKrishakReport(params) {
        var response = this._postXMLData(API_CONSTANTS.EXPORT_KRISHAK_REPORT, params)
        return response;
    }

    static exportUserLocationReport(params) {
        var response = this._postXMLData(API_CONSTANTS.EXPORT_USER_LOCATION_REPORT, params)
        return response;
    }

    static exportActivityReport(params) {
        var response = this._postXMLData(API_CONSTANTS.EXPORT_ACTIVITY_REPORT, params)
        return response;
    }

    static exportUserReport(params) {
        var response = this._postXMLData(API_CONSTANTS.EXPORT_USER_REPORT, params)
        return response;
    }

    static exportPrerakReport(params) {
        var response = this._postXMLData(API_CONSTANTS.EXPORT_PRERAK_REPORT, params)
        return response;
    }

    static getActivityReport(params) {
        var response = this._postData(API_CONSTANTS.GET_ACTIVITY_REPORT, params)
        return response;
    }

    static farmerReport(params) {
        var response = this._postData(API_CONSTANTS.FARMER_REPORT, params)
        return response;
    }

    static userReport(params) {
        var response = this._postData(API_CONSTANTS.USER_REPORT, params)
        return response;
    }

    static prerakReport(params) {
        var response = this._postData(API_CONSTANTS.PRERAK_REPORT, params)
        return response;
    }

    static getAllCropGroup(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_CROP_GROUP, params)
        return response;
    }

    static getAllUserFeedbackTopic(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_USER_FEEDBACK, params)
        return response;
    }

    static getAllApps(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_APPS, params)
        return response;
    }

    static getAllQualification(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_QUALIFICATION, params)
        return response;
    }

    static getAllKrishakDecisionMaking(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_DECISION_MAKING, params)
        return response;
    }

    static getAllIrrigationSource(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_IRRIGATION_SOURCE, params)
        return response;
    }

    static getAllInfluenceFactor(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_INFLUENCE_FACTORS, params)
        return response;
    }

    static getAllKrishakSourceOfInformation(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_SOURCE_OF_INFORMATION, params)
        return response;
    }

    static getAllCrop(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_CROPS, params)
        return response;
    }
    static getAllActiveCrop(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_ACTIVE_CROP, params)
        return response;
    }

    static addkrishak(params) {
        var response = this._postFormData(API_CONSTANTS.ADD_KRISHAK, params)
        return response;
    }

    static addUserFeedback(params) {
        var response = this._postFormData(API_CONSTANTS.ADD_USER_FEEDBACK, params)
        return response;
    }

    static updateUserImage(params) {
        var response = this._postFormData(API_CONSTANTS.UPDATE_USER_IMAGE, params)
        return response;
    }

    static getUserNotification(params) {
        var response = this._postFormData(API_CONSTANTS.GET_USER_NOTIFICATION, params)
        return response;
    }

    static updateUserNotification(params) {
        var response = this._postData(API_CONSTANTS.UPDATE_USER_NOTIFICATION, params)
        return response;
    }

    static getUserById(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_BY_ID, params)
        return response;
    }

    static getAllAreaUnit(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_AREA_UNIT, params)
        return response;
    }

    static getAllWeightUnit(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_WEIGHT_UNIT, params)
        return response;
    }

    static editUser(params) {
        var response = this._postData(API_CONSTANTS.EDIT_USER, params)
        return response;
    }

    static editkrishak(params) {
        var response = this._postFormData(API_CONSTANTS.EDIT_KRISHAK, params)
        return response;
    }

    static deleteKrishak(params) {
        var response = this._postData(API_CONSTANTS.DELETE_KRISHAK, params)
        return response;
    }

    static getKrishakById(params) {
        var response = this._postData(API_CONSTANTS.GET_KRISHAK_BY_ID, params)
        return response;
    }

    static getAllRetailer(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_RETAILERS, params)
        return response;
    }

    static getKrishakParam() {
        var response = this._postData(API_CONSTANTS.GET_KRISHAK_PARAM)
        return response;
    }

    static getAllHybrid(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_HYBRIDS, params)
        return response;
    }

    static getHybridByMultiCrop(params) {
        var response = this._postData(API_CONSTANTS.GET_HYBRID_BY_MULTI_CROP, params)
        return response;
    }

    static getCompetitorHybridByMultiCrop(params) {
        var response = this._postData(API_CONSTANTS.GET_COMPETITOR_HYBRID_BY_MULTI_CROP, params)
        return response;
    }

    static getAllTehsilByReferenceId(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_TEHSIL_BY_ID, params);
        return response;
    }

    static getAddressFromLatLong(params) {
        var response = this._postData(API_CONSTANTS.GET_ADDRESS_FROM_LAT_LONG, params);
        return response;
    }

    static getAvailableMobileNumber(params) {
        var response = this._postData(API_CONSTANTS.GET_AVAILABLE_MOBILE_NUMBER, params);
        return response;
    }

    static getAllDistrictByReferenceId(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_DISTRICT_BY_ID, params);
        return response;
    }

    static getAllVillageById(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_VILLAGE_BY_ID, params);
        return response;
    }

    static getHybridById(params) {
        var response = this._postData(API_CONSTANTS.GET_HYBRID_BY_ID, params)
        return response;
    }


    // Added By Krunal
    static getAllCropHybridByUserLocation(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_CROP_HYBRID_BY_USER_LOCATION, params);
        return response;
    }

    static getAllUserLocationByHybrid(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_USER_LOCATION_BY_HYBRID, params);
        return response;
    }

    //***** Dashboard Module *****//
    static getDashboardData(params) {
        var response = this._postData(API_CONSTANTS.GET_DASHBOARD_DATA, params);
        return response;
    }

    static getDashboardDownloadData(params) {
        var response = this._postData(API_CONSTANTS.GET_DASHBOARD_DOWNLOAD_DATA)
        return response;
    }

    //***** Calender Module *****//
    static getCalendarActivityByMonth(params) {
        var response = this._postData(API_CONSTANTS.GET_CALENDAR_ACTIVITY_BY_MONTH, params);
        return response;
    }

    static getActivityByDate(params) {
        var response = this._postData(API_CONSTANTS.GET_ACTIVITY_BY_DATE, params);
        return response;
    }

    static getUserActivityByDate(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_ACTIVITY_BY_DATE, params);
        return response;
    }

    static editActivityById(params) {
        var response = this._postData(API_CONSTANTS.EDIT_ACTIVITY_BY_ID, params);
        return response;
    }

    static getAllReject(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_REJECT, params);
        return response;
    }

    static addActivityReject(params) {
        var response = this._postData(API_CONSTANTS.ADD_ACTIVITY_REJECT, params);
        return response;
    }

    //***** Sample To Sale Module *****//
    static isSampleToSale(params) {
        var response = this._postData(API_CONSTANTS.IS_SAMPLE_TO_SALE, params);
        return response;
    }

    static storeSampleToSaleById(params) {
        var response = this._postFormData(API_CONSTANTS.STORE_SAMPLE_TO_SALE_BY_ID, params);
        return response;
    }

    static getCropDaysByCropId(params) {
        var response = this._postData(API_CONSTANTS.GET_CROP_DAYS_BY_CROP_ID, params);
        return response;
    }

    //***** Reports Masters*****//
    static getUserState(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_STATE, params);
        return response;
    }

    static getAllActiveDistrict(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_ACTIVE_DISTRICT, params);
        return response;
    }

    static getActiveTehsilByDistrictId(params) {
        var response = this._postData(API_CONSTANTS.GET_ACTIVE_TEHSIL_BY_DISTRICT_ID, params);
        return response;
    }

    static getAllVillageByUser(params) {
        var response = this._postData(API_CONSTANTS.GET_ALL_VILLAGE_BY_USER, params);
        return response;
    }

    static getUserCropGroup(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_CROP_GROUP, params);
        return response;
    }

    static getUserCrop(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_CROP, params);
        return response;
    }

    static getTypeOfSampleByUser(params) {
        var response = this._postData(API_CONSTANTS.GET_TYPE_OF_SAMPLE_BY_USER, params);
        return response;
    }

    static getActiveSeason(params) {
        var response = this._postData(API_CONSTANTS.GET_ACTIVE_SEASON, params);
        return response;
    }

    static getSubActivities(params) {
        var response = this._postData(API_CONSTANTS.GET_SUB_ACTIVITY_BY_USER, params);
        return response;
    }

    static getUserReportingUserDetails(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_REPORTING_USER_DETAILS, params);
        return response;
    }


    //***** Daksh Module *****//
    static addDakshData(params) {
        var response = this._postData(API_CONSTANTS.ADD_DAKSH_DATA, params);
        return response;
    }

    static getDakshDataByRetailerId(params) {
        var response = this._postData(API_CONSTANTS.GET_DAKSH_DATA_BY_RETAILER_ID, params);
        return response;
    }

    static getOTPCodeInDaksh(params) {
        var response = this._postData(API_CONSTANTS.GET_OTP_CODE_IN_DAKSH, params);
        return response;
    }

    static validateOTP(params) {
        var response = this._postData(API_CONSTANTS.VALIDATE_OTP, params);
        return response;
    }

    static getDakshApprovalList(params) {
        var response = this._postData(API_CONSTANTS.GET_DAKSH_APPROVAL_LIST, params);
        return response;
    }

    static getDakshDataByDakshId(params) {
        var response = this._postData(API_CONSTANTS.GET_DAKSH_DATA_BY_DAKSH_ID, params);
        return response;
    }

    static updateDakshStatus(params) {
        var response = this._postData(API_CONSTANTS.UPDATE_DAKSH_STATUS, params);
        return response;
    }

    static getDakshRejectReason(params) {
        var response = this._postData(API_CONSTANTS.GET_DAKSH_REJECT_REASON, params);
        return response;
    }


    //Dashboard New APIs
    static getDashboardMasterData(params) {
        var response = this._postData(API_CONSTANTS.GET_DASHBOARD_MASTER_DATA, params);
        return response;
    }

    static getDashboardActivityData = async (params) => {
        var response = await this._postData(API_CONSTANTS.GET_DASHBOARD_ACTIVITY_DATA, params);
        return response;
    }

    static getDashboardUserData(params) {
        var response = this._postData(API_CONSTANTS.GET_DASHBOARD_USER_DATA, params);
        return response;
    }

    static getDashboardTehsilData(params) {
        var response = this._postData(API_CONSTANTS.GET_DASHBOARD_TEHSIL_DATA, params);
        return response;
    }

    static getDashboardHybridData(params) {
        var response = this._postData(API_CONSTANTS.GET_DASHBOARD_HYBRID_DATA, params);
        return response;
    }

    //User Status Reports
    static getUserStatusReports(params) {
        var response = this._postData(API_CONSTANTS.GET_USER_REPORTS, params);
        return response;
    }


    // For Report Optimization
    static getReport(params) {
        var response = this._postData('getReport', params);
        return response;
    }

    static addReport(params) {
        var response = this._postData('addReport', params);
        return response;
    }

}